import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAgents } from "@/components/Agents/AgentsContext";
import { agentsHref } from "@/lib/atwAgentsHost";
import { scheduleCadenceLabel } from "@/lib/agentsDemoData";

export function SchedulesPage() {
  const { org, may, viewOnly } = useAgents();
  const navigate = useNavigate();
  const canManage = may("manage_schedules");

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Schedules</h1>
          <p className="mt-1 max-w-2xl text-sm text-gray-600 dark:text-gray-400">
            A schedule is a named clock for the organization. Create it once, then assign it to as
            many agents as you need.
          </p>
        </div>
        <Button
          type="button"
          disabled={!canManage}
          onClick={() => navigate(agentsHref("/schedules/new"))}
          title={
            viewOnly
              ? "Standard role is view only. Ask a Super Admin to add a schedule."
              : "Add a schedule"
          }
        >
          <Plus className="size-4" aria-hidden />
          Schedule
        </Button>
      </div>

      {viewOnly ? (
        <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100">
          Standard role is view only. Ask a Super Admin to add a schedule.
        </p>
      ) : null}

      {org.schedules.length === 0 ? (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">No schedules yet</CardTitle>
            <CardDescription>Add a schedule, then assign it on an agent.</CardDescription>
          </CardHeader>
        </Card>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {org.schedules.map((schedule) => (
            <Card key={schedule.id}>
              <CardHeader>
                <CardTitle className="text-base">{schedule.name}</CardTitle>
                <CardDescription>{scheduleCadenceLabel(schedule.cadence)}</CardDescription>
              </CardHeader>
              {schedule.note ? (
                <CardContent>
                  <p className="text-sm text-muted-foreground">{schedule.note}</p>
                </CardContent>
              ) : null}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
